<div class="modal-header">
  <h4 class="modal-title">Proposal Vote Email</h4>
</div>
@if (proposal) {
  <div class="modal-body">
    <div style="margin-bottom: 5px">
      <strong>Proposal: {{ proposal.description }}</strong>
    </div>
    <div class="d-flex" style="margin-top: 15px">
      <div>
        <label class="mt-2 me-2">Send To</label>
      </div>
      <div>
        <dx-select-box
          [(value)]="selectedCommitteeId"
          [items]="committees"
          [valueExpr]="'id'"
          [displayExpr]="'name'"
          (onSelectionChanged)="selectionChanged($event)"
        ></dx-select-box>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <strong>
        {{ !!members ? members.length + ' people' : '' }}
      </strong>
    </div>
    @if (selectedCommitteeId === 17 && !memberCommitteeLoaded) {
      <div>
        <td colspan="12">
          <strong>{{ memberMessage }}</strong>
        </td>
      </div>
    }
    @if (members) {
      <div class="widget-content user">
        <table class="table table-hover">
          <thead [hidden]="members.length > 0 || selectedCommitteeId === 17">
            <tr>
              <th>Person</th>
              <th>Email</th>
              <th>Cell</th>
            </tr>
          </thead>
          <tbody>
            <tr [hidden]="members.length > 0 || selectedCommitteeId === 17">
              <td colspan="9">No Data</td>
            </tr>
            @if (members.length === 0 || selectedCommitteeId === 17) {
              <div>
                <tr>
                  <td colspan="12">
                    <h3>
                      <strong>Members who meet the following criteria will receive a vote</strong>
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td colspan="9">
                    <h3>-- Status of 'Professing Member' in ARK</h3>
                  </td>
                </tr>
                <tr>
                  <td colspan="9">
                    <h3>-- Older than 18 years and not deceased</h3>
                  </td>
                </tr>
                <tr>
                  <td colspan="9">
                    <h3>-- Email is not blank, whitespace, or listed as UnListed</h3>
                  </td>
                </tr>
              </div>
            }
            <tr [hidden]="members.length > 0 || selectedCommitteeId !== 17">
              <td colspan="9"></td>
            </tr>
            @for (member of members; track member) {
              <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="members.length === 0">
                <td style="padding: 6px">{{ member.person.displayName }}</td>
                <td style="padding: 6px">{{ member.person.email }}</td>
                <td style="padding: 6px">{{ member.person.cellPhone }}</td>
                <td style="padding: 6px"><i class="fa fa-times" (click)="remove(member.personId)"></i></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}
<div class="modal-footer">
  @if (selectedCommitteeId === 17) {
    <button class="btn btn-primary" (click)="save()" [disabled]="processing">Generate Votes</button>
  }
  @if (selectedCommitteeId !== 17) {
    <button  class="btn btn-primary" (click)="save()" [disabled]="processing">Send Email</button>
  }
  @if (selectedCommitteeId !== 17) {
    <button class="btn btn-success" (click)="save(true)" [disabled]="processing">Send Text</button>
  }
  <button class="btn btn-secondary" (click)="close()">Cancel</button>
</div>
